import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarVisible = new BehaviorSubject<boolean>(false);
  sidebarVisible$ = this.sidebarVisible.asObservable();

  toggle(): void {
    this.sidebarVisible.next(!this.sidebarVisible.value);
  }

  close(): void {
    this.sidebarVisible.next(false);
  }
} 